import AXIOS from '@/axios-instance';

export default {
    savePXQuestion(question){
        return AXIOS.post("/px/question", question);
    },
    removePBQuestion(questionId){
        return AXIOS.delete("/px/question/PB/"+questionId)
    },
    removePXQuestion(questionId){
        return AXIOS.delete("/px/question/"+questionId)
    },
    retrievePXQuestions() {
        return AXIOS.get("/px/question");
    },
    retrievePXQuestionOverview() {
        return AXIOS.get("/px/question/overview");
    },
    retrievePXProcessBasedQuestionOverview() {
        return AXIOS.get("/px/question/overview/PB");
    },
    retrievePXQuestionsByModule(mod) {
        return AXIOS.get("/px/question/module/"+mod);
    },
    retrievePXProcessActivityQuestions() {
        return AXIOS.get("/px/question/process");
    },
    retrievePXProcessQuestions(uuid) {
        return AXIOS.get("/px/question/process/"+uuid);
    },
    retrievePXRoleQuestions() {
        return AXIOS.get("/px/question/role");
    },
    retrievePXUserQuestions() {
        return AXIOS.get("/px/question/user");
    },
    retrievePxIwakQuestionsForElement(){
        return AXIOS.get("/question/element/Activity");
    },
    getElementTypes(){
        return AXIOS.get("/px/question/types");
    },
    getCustomQuestions(){
        return AXIOS.get("/px/question/type/NONE");
    }
}